import { DadosDaPesquisaOrcamento } from "app/types/pesquisa-orcamento/PesquisaOrcamento";
import { Dict } from "app/utils/Dict";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { MenuConsultasPesquisaOrcamento } from "./MenuConsultasPesquisaOrcamento";
import { obterPermissao } from "app/use-cases/obterPermissao";
import { Permissao } from "app/types/Permissao";
import { removerComponenteReact, renderizarComponentReact } from "../../renderizarOuRemoverComponentReact";
import { NotasFiscaisContainer } from "../notas-fiscais/NotasFiscaisContainer";
import { ConhecimentoTransporteContainer } from "../conhecimento-transporte/ConhecimentoTransporteContainer";
import { HistoricoOrcamentoContainer } from "../historico-orcamento/HistoricoOrcamentoContainer";
import { DevolucoesOrcamentoContainer } from "../devolucoes-orcamento/DevolucoesOrcamentoContainer";
import { CadastrarAtendimentoContainer } from "app/components/atendimento/CadastrarAtendimento/CadastrarAtendimentoContainer";

export type MenuConsultasPesquisaOrcamentoContainerProps = {
    orcamentoSelecionado: Partial<DadosDaPesquisaOrcamento>;
    onSelecionadoMenu: () => void;
    onVoltar: () => void;
    passos: Dict<string, () => void>;
}

export type MenuConsultaPesquisaOrcamento = {
    orcamentoSelecionado: Partial<DadosDaPesquisaOrcamento>;
    onVoltar: () => void;
    passos: Dict<string, () => void>;
    onRemover?: () => boolean;
}


export const MenuConsultasPesquisaOrcamentoContainer = (props: MenuConsultasPesquisaOrcamentoContainerProps) => {
    const [permissoes, setPermissoes] = useState<Permissao[]>([])
    const [parametrosCarregados, setParametrosCarregados] = useState(false)
    const isMounted = useRef<boolean>(true)

    const atualizarPermissoes = useCallback(async () => {
        const [nf, conhecimentoTransporte, ctdevolucao, atendimento] = await Promise.all([
            obterPermissao({ funcionalidade: "PESQUISAR_ORCAMENTO", acao: "CONSULTAR_NF_ORCAMENTO" }),
            obterPermissao({ funcionalidade: "PESQUISAR_ORCAMENTO", acao: "CONSULTAR_CONHECIMENTO_TRANSPORTE" }),
            obterPermissao({ funcionalidade: "PESQUISAR_ORCAMENTO", acao: "CONSULTAR_DEVOLUCOES_ORCAMENTO" }),
            obterPermissao({ funcionalidade: "ORCAMENTO_ATENDIMENTO_CLIENTES", acao: "INCLUIR"}), // 489353
        ])
        if (!isMounted.current) return
        setPermissoes([
            { Acao: "CONSULTAR_NF_ORCAMENTO", Permitido: nf },
            { Acao: "CONSULTAR_CONHECIMENTO_TRANSPORTE", Permitido: conhecimentoTransporte },
            { Acao: "CONSULTAR_DEVOLUCOES_ORCAMENTO", Permitido: ctdevolucao },
            { Acao: "INCLUIR_ATENDIMENTO_CLIENTES", Permitido: atendimento }, // 89353
        ])
        setParametrosCarregados(true)
    }, [])

    const propsBase = useMemo<MenuConsultaPesquisaOrcamento>(() => ({
        orcamentoSelecionado: props.orcamentoSelecionado,
        onRemover: () => removerComponenteReact("pesquisar-pedidos-region"),
        onVoltar: () => props.onVoltar(),
        passos: props.passos,
    }), [props.orcamentoSelecionado, props.passos, props.onVoltar])

    const onRenderizarNotasFiscais = useCallback(() => {
        renderizarComponentReact(<NotasFiscaisContainer {...propsBase} />, "pesquisar-pedidos-region", true);
    }, [propsBase])

    const onRenderizarConhecimentoTransporte = useCallback(() => {
        renderizarComponentReact(<ConhecimentoTransporteContainer {...propsBase} />, "pesquisar-pedidos-region", true);
    }, [propsBase])

    const onRenderizarDevolucoes = useCallback(() => {
        renderizarComponentReact(<DevolucoesOrcamentoContainer {...propsBase} />, "pesquisar-pedidos-region", true);
    }, [propsBase])

    const onRenderizarHistoricoOrcamento = useCallback(() => {
        renderizarComponentReact(<HistoricoOrcamentoContainer {...propsBase} />, "pesquisar-pedidos-region", true);
    }, [propsBase])


    useEffect(() => {
        atualizarPermissoes()
        return () => { isMounted.current = false }
    }, [])

    return (
        <>
            {parametrosCarregados &&
                <MenuConsultasPesquisaOrcamento
                    permitirVisualiarNotasFiscais={permissoes?.find((permissao) => permissao.Acao == "CONSULTAR_NF_ORCAMENTO")?.Permitido}
                    permitirVisualiarConhecimentoTransporte={permissoes?.find((permissao) => permissao.Acao == "CONSULTAR_CONHECIMENTO_TRANSPORTE")?.Permitido}
                    permitirVisualiarDevolucoes={permissoes?.find((permissao) => permissao.Acao == "CONSULTAR_DEVOLUCOES_ORCAMENTO")?.Permitido}
                    onRenderizarHistoricoOrcamento={onRenderizarHistoricoOrcamento}
                    onSelecionadoMenu={props.onSelecionadoMenu}
                    onRenderizarNotasFiscais={onRenderizarNotasFiscais}
                    onRenderizarConhecimentoTransporte={onRenderizarConhecimentoTransporte}
                    onRenderizarDevolucoes={onRenderizarDevolucoes}
                />
            }
        </>
    )
}
